export default __webpack_public_path__ + "static/media/Weissenberg.f6073e69.png";